import axios, { AxiosResponse, ResponseType } from 'axios';
import { getTokenFromQuery } from '../../../features/auth/utils/auth.utils';
import { EndpointsType } from '../model/API.endpoints';

export const createQueryKey = (
  endpoint: EndpointsType | string,
  params?: Record<string, unknown>,
  userId?: number | string
): (string | number | Record<string, unknown>)[] => {
  const key: (string | number | Record<string, unknown>)[] = [endpoint];
  
  if (params && Object.keys(params).length > 0) {
    key.push(params);
  }

  if (userId !== undefined && userId !== null) {
    key.push(`user:${userId}`);
  }
  
  return key;
};

export const fetchData = async <T>(
  endpoint: EndpointsType | string,
  params: Record<string, unknown>,
  responseType?: ResponseType
): Promise<T> => {
  const url = `${endpoint}`;
  const headers = {
    Authorization: `Bearer ${getTokenFromQuery()}`,
  };

  const response: AxiosResponse<T> = await axios.get(url, {
    params,
    headers,
    responseType,
    method: 'get',
  });

  return response.data;
};
